import { motion } from "framer-motion";
import { Activity, ShieldCheck, Zap } from "lucide-react";

export default function SystemWidget() {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.8 }}
      className="w-full max-w-xs p-4 rounded-2xl bg-[var(--glass-bg)] border border-[var(--glass-border)] backdrop-blur-xl shadow-2xl"
    >
      <div className="flex justify-between items-center mb-4 border-b border-[var(--glass-border)] pb-2">
        <span className="text-[10px] font-mono text-[var(--text-muted)] uppercase tracking-widest">Live Metrics</span>
        <div className="flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-[var(--safe-emerald)] animate-pulse" />
          <span className="text-[10px] font-bold text-[var(--safe-emerald)]">ONLINE</span>
        </div>
      </div>

      <div className="space-y-3">
        {/* Metric 1 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded bg-[var(--nily-teal)]/10 text-[var(--nily-teal)]"><Activity size={14} /></div>
            <span className="text-xs font-medium text-[var(--text-primary)]">Global Mood</span>
          </div>
          <span className="text-xs font-mono text-[var(--nily-teal)]">STABLE</span>
        </div>

        {/* Metric 2 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded bg-[var(--neurova-purple)]/10 text-[var(--neurova-purple)]"><Zap size={14} /></div>
            <span className="text-xs font-medium text-[var(--text-primary)]">Neurova Engine</span>
          </div>
          <span className="text-xs font-mono text-[var(--text-primary)]">PROCESSING</span>
        </div>

        {/* Metric 3 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded bg-[var(--safe-emerald)]/10 text-[var(--safe-emerald)]"><ShieldCheck size={14} /></div>
            <span className="text-xs font-medium text-[var(--text-primary)]">Privacy Core</span>
          </div>
          <span className="text-xs font-mono text-[var(--safe-emerald)]">ACTIVE</span>
        </div>
      </div>
    </motion.div>
  );
}
